export const generateDownloadUrl = (path: string) => {
  // Ensure window is defined (i.e., we're in the browser)
  if (typeof window === "undefined") return ""

  const baseUrl = `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? ":" + window.location.port : ""
  }`

  return `${baseUrl}${path}?download=1`
}

export const verifyDownloadUrl = (url: string) => {
  const params = new URLSearchParams(url.split("?")[1])
  const download = params.get("download")

  return download === "1" ? true : false
}
